import type { RefObject } from 'react';
import TextTooltipEcho from './TextTooltipEcho';

interface ImpressionsTooltipEchoProps {
  popoverRef: RefObject<HTMLDivElement>;
}

/**
 * Echo variant of {@link TotalImpressionsTooltip}: Ant Design tooltip instead of Decibel popover.
 */
export const TotalImpressionsTooltipEcho = ({ popoverRef }: ImpressionsTooltipEchoProps) => {
  return (
    <TextTooltipEcho
      popoverRef={popoverRef}
      title="Total impressions for impression-based campaigns"
      description="This total includes only impressions delivered for campaigns paid on an impression basis. It does not include campaigns with other payment models."
      buttonText="Impressions"
    />
  );
};

/**
 * Echo variant of {@link ImpressionsNotApplicableTooltip}.
 */
export const ImpressionsNotApplicableTooltipEcho = ({ popoverRef }: ImpressionsTooltipEchoProps) => {
  return (
    <TextTooltipEcho
      popoverRef={popoverRef}
      title="Not applicable"
      description="Earnings are not calculated based on impressions for this campaign type."
      buttonText="n/a"
    />
  );
};
